import {config} from '../config';

export default {
    getIsHomePageEnabled: () => config.data.homePage.isHomePageEnabled,
    getHomePageForYouSection: () => config.data.homePage.forYouSection,
    getLearnHowToUseDataByDeviceType: (deviceType) => config.data.homePage.forYouSection?.learnHowToUse[deviceType],
    getIsUsageEnabled: () => config.data.homePage.isUsageEnabled,
};
